import axios from "axios";

export const savePersonaInformation = (data, callback) => {
  var promise = axios({
    method: "put",
    url: "/api/profiles",
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

